import React from 'react'
import icons from '../../data/icons.ts'
import ViewMapButton from './ViewMapButton.tsx'

const MapDetail = (props) => {

  const currentDetail = props.mapData.pins.filter(loc => loc.id === props.activeDetail)[0]

  const currentCategory = props.mapData.categories.filter((category: any) => {
    if (!currentDetail || !currentDetail.category) return false
    return category.id === currentDetail.category.id
  }).pop()

  if (!props.activeDetail) return (<></>)

  return (
    <>
      <button onClick={() => { props.setDetailsPanelActive(false) }} type="button" className="nsw-button nsw-button--dark-outline sopa-map--back-button">
        <span className="nsw-material-icons material-icons">
          arrow_back
        </span>
        <span>Back</span>
      </button>
      <ViewMapButton handleToggleFilter={props.handleToggleFilter} />
      <h2 dangerouslySetInnerHTML={{ __html: `${currentDetail.title}` }}></h2>
      {currentCategory && <span className="sopa-map--details_venue" dangerouslySetInnerHTML={{ __html: `${icons.logoCircle.svg}<span>${currentCategory.name}</span>` }} />}

      {currentDetail.image.url && <div className="sopa-map--details_img"><img src={currentDetail.image.url} alt={currentDetail.image.alt} /></div>}

      {currentDetail.description &&
        <div className="sopa-map--details_description">
          <h3 className="large">Description</h3>
          <div className="sopa--poi-list_description" dangerouslySetInnerHTML={{ __html: `${currentDetail.shortDescription}` }}></div>
        </div>
      }
      {currentDetail.address &&
        <div className="sopa-map--details_address">
          <h3 className="large">Address</h3>
          <address className="intro">{currentDetail.address}</address>
        </div>
      }

      <div className="sopa-map--details_actions">
        {currentDetail.optionalButton !== null && currentDetail.optionalButton.url && <a target="_blank" href={currentDetail.optionalButton.url} className="nsw-button nsw-button--dark">{currentDetail.optionalButton.title}</a>}
        <a target="_blank" href={`https://www.google.com.au/maps/dir/?api=1&destination=${currentDetail.geofield.lat},${currentDetail.geofield.lon}`} className="sopa-map--details_actions-directions nsw-button nsw-button--dark-outline"><span>Get Directions</span> <span className="nsw-material-icons material-icons">turn_right</span></a>
      </div>

      <button type="button" className="sopa-map--details-back" onClick={() => { props.setDetailsPanelActive(false) }}>Back to search</button>
    </>
  )
}

export default MapDetail
